import { render, staticRenderFns } from "./resumeEvent.vue?vue&type=template&id=77b8d5f2&"
import script from "./resumeEvent.vue?vue&type=script&lang=ts&"
export * from "./resumeEvent.vue?vue&type=script&lang=ts&"
import style0 from "./resumeEvent.vue?vue&type=style&index=0&id=77b8d5f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports